import styled from "styled-components";

export const Container = styled.div`
    width: 100%;
    padding: 0px 100px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 23px;

    @media (max-width: 768px){
     padding: 0px 16px;
     grid-template-columns: repeat(1, 1fr); 
    }

`;

export const MobileViewVisibility = styled.div`
    display: none;    

    @media (max-width: 768px){
        display: block;    
    }
`;

export const DesktopViewVisibility = styled.div`

    display: block;    

    @media (max-width: 768px){
        display: none;    
    }

`;

export const Card = styled.div`
    width: 100%;
    padding: ${props => props?.padding ? props?.padding : '8px'};
    border-radius: 8px;
    background: var(--surface-white-bg, #FFF);
`;

export const ImageLinkWrapper = styled.a`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    width: ${props => props.width ? props.width : "150px"};
    height: ${props => props.height ? props.height : "162px"};
    margin-right: 8px;

    @media (max-width: 768px){
        width: 100%;
        height: 150px;  
        object-fit: cover;
        margin-bottom: 12px;  
        margin-right: 0;
        display: block;
    }

`;

export const ImageButtonWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    width: ${props => props.width ? props.width : "150px"};
    height: ${props => props.height ? props.height : "162px"};
    margin-right: 8px;

    @media (max-width: 768px){
        width: 100%;
        height: 150px;  
        object-fit: cover;
        margin-bottom: 12px;  
        margin-right: 0;
        display: block;
    }

`;

export const ClickHereContainer = styled.div`
    position: absolute;
    font-size: 10px; 
    color: #292929;
    font-weight: 500;
    bottom: 8px;
    left: 8px;
    background: rgb(233,233,233, 0.8);
    border-radius: 10px;
    padding: 5px;

    .click_text{
        display: flex;
        align-items: center;
        gap: 2px;
    }
`;

export const Image = styled.img`
    width: 150px;
    height: 162px;
    border-radius: 8px;
    ${props => props?.modal ? `
    width: 338.462px;
    `:''}
    ${props => props?.modal ? `
    height: 338.462px;
    `:''}
    object-fit: cover;

    @media (max-width: 768px){
        width: 100%;
        height: 150px;  
        object-fit: cover;
        margin: 0px 0px 12px 0px;  
    }
`; 

export const BasicInfoContainer = styled.div`
    display: flex;
    margin-bottom: 24px;

    @media (max-width: 768px){
        display: flex;
        flex-direction: column;  
    }

`;

export const TitleContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 62px;
`;

export const TextContainer = styled.div`
    max-width: 256.857px;
`;

export const Title = styled.p`
    word-break: break-word;
    color: var(--text-primary-text, #333);
    font-size: 16px;
    font-weight: 700;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;  
    overflow: hidden;
`;

export const SmallText = styled.small`
    color: var(--text-secondary-text, #666);
    font-size: 12px;
    font-weight: 400;
`;

export const MoreInfoButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 4px;
    height: 28px;
    padding: 6px;
    border-radius: 4px;
    background: var(--surface-action-50, #FFF4E2);
    color: var(--text-action-text, #F37021);
    font-size: 10px;
    font-weight: 400;
`;

export const InfoIcon = styled.img`
    width: 16px;
    height: 16px;
`;

export const BasicInfoMainContainer = styled.div`
    margin-top: 12px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 16px;
    ${props => props?.modal ? `
    display: flex;
    gap: 57px;
    `:''}
`;

export const IconTextContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
`;

export const TextLabelContainer = styled.div`
    max-width: 108px;
    display: flex;
    flex-direction: column;
    word-break: break-word;
`;

export const Text = styled.p`
    color: var(--text-primary-text, #333);
    font-size: 14px;
    font-weight: 700;
`;

export const Label = styled.label`
    color: var(--text-primary-text, #333);
    font-size: 12px;
    font-weight: 400;
`;

export const Price = styled.p`
    color: #333;
    font-size: 18px;
    font-weight: 700;
`;

export const IconContainer = styled.div`
    width: 28px;
    height: 28px;
    background-color: var(--surface-brand-50, #F1E5F1);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
`;

export const Icon = styled.img`
    width: 18px;
    height: 17.73px;
`;

export const RupeeText = styled.span`
    position: absolute;
    left: 10px;
    color: var(--text-secondary-text, #666);
    font-size: 14px;
    font-weight: 400;
`;

export const ButtonContainer = styled.div`
    display: flex;
    align-items: center;

    @media (max-width: 768px){
        justify-content: space-between;   
    }

`;

export const InputButtonContainer = styled.div`
    min-width: 311.622px;
    max-width: ${props => props.modal ? `500px`: '400.622px'};
    display: flex;
    align-items: center;
    margin-left: auto;    
    
    @media (max-width: 768px){
        min-width: 100%;
        max-width: 100%;
        margin-left: 0px;    
    }

`;

export const Input = styled.input`
    border: none;
    min-height: 34px;
    padding-left: 20px; 
    width: ${props => props.width ? props.width : "100%"};
`;

export const InputIconContainer = styled.div`
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    height: 36px;
    border-radius: 4px 0px 0px 4px;
    border: 1px solid var(--border-gray-300, #CCC);
    background: var(--surface-white-bg, #FFF);
    @media (max-width: 768px){
        width: 50%;   
    }
`;

export const Button = styled.button`
    width: ${props => props.width ? props.width : "100%"};    ;
    min-height: 36px;
    padding: 10px;
    border-radius: 0px 4px 4px 0px;
    background: ${props => props.backgroundColor ? props.backgroundColor : `var(--surface-action, #F37021)`};
    color: ${props => props.color ? props.color : `var(--text-white-text, #FFF)`};
    font-size: 11px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media (max-width: 768px){
        width: 50%; 
    }
`;

export const ReportLink = styled.a`
    width: 156px;
    padding: 10px;
    gap: 8px;
    margin-right: 35px;
    text-decoration: none;
    color: var(--text-action-text, #F37021);
    font-size: 14px;
    font-weight: 400;
    border-radius: 4px;
    border: 1px solid var(--border-action, #F37021);
    background: var(--surface-white-bg, #FFF);
    display: flex;
    align-items: center;

    &;hover,
    &:focus{
        background: var(--surface-action-50, #FFF4E2);
    }

    @media (max-width: 768px){
        margin-right: 0px;
        max-width: 156px;  
    }

`;

export const MoreInfoContainer = styled.div`
    margin-top: 12px;
    display: flex;
    flex-wrap: wrap;
    gap: 15px;

    @media (max-width: 768px){
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 16px;    
    }

`;

export const MoreInfoLabel = styled.p`
    color: var(--text-primary-text, #333);
    font-size: 12px;
    font-weight: 700;
    margin: 25px 12px 0px 0px;
`;

export const ViewMoreButton = styled.button`
    color: var(--text-action-text, #F37021);
    background-color: #FFFFFF;
    font-size: 14px;
    font-weight: 400;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 12px;
`;